var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay-dialog" }, [
    !_vm.displayConfirm
      ? _c(
          "div",
          [
            _c("h2", {
              staticClass: "overlay-dialog__title",
              domProps: { innerHTML: _vm._s(_vm.$t("cart.timeEdit.title")) }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-dialog__text" },
              [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.$t("cart.timeEdit.text")) }
                }),
                _vm._v(" "),
                _c("Button", {
                  staticClass: "overlay-dialog__text-button",
                  attrs: {
                    level: "tertiary",
                    type: "button",
                    text: _vm.$t("cart.timeEdit.cancelButton"),
                    arrow: "",
                    reverse: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("GeneralMessage", {
                  attrs: { message: _vm.errorMessage, type: "error" },
                  on: {
                    close: function($event) {
                      _vm.errorMessage = ""
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.locationOrderMinDate && _vm.locationOrderMaxDate
              ? _c("OrderBoxTime", {
                  staticClass: "order-box__time--overlay",
                  attrs: {
                    "uber-direct": _vm.locationOrderUberDirect,
                    "order-now": _vm.locationOrderNow,
                    "order-now-available": _vm.cartOrderNowAvailable,
                    date: _vm.selectedDate,
                    dateMin: _vm.locationOrderMinDate.format("L"),
                    dateMax: _vm.locationOrderMaxDate.format("L"),
                    isDateDisabled: _vm.isDateDisabled.bind(this),
                    time: _vm.selectedTime,
                    times: _vm.locationOrderTimes,
                    buttonText: _vm.$t("cart.timeEdit.acceptButton"),
                    "yielding-messages": _vm.yieldingMessages
                  },
                  on: {
                    ordernowchanged: _vm.onLocationOrderNowChange,
                    datechanged: _vm.onLocationDateSelect,
                    timechanged: _vm.onLocationTimeSelect,
                    click: function($event) {
                      return _vm.onTimeChange()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          [
            _c("h2", {
              staticClass: "overlay-dialog__title",
              domProps: {
                innerHTML: _vm._s(_vm.$t("cart.timeEdit.cartChange.title"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "overlay-dialog__text" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("cart.timeEdit.cartChange.text"))
                }
              })
            ]),
            _vm._v(" "),
            _c("CartChanges", {
              attrs: {
                text: _vm.$t("cart.timeEdit.cartChange.changeTitle"),
                changes: _vm.cartChangedItems
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-dialog__buttons" },
              [
                _c("Button", {
                  attrs: {
                    level: "tertiary",
                    type: "button",
                    text: _vm.$t("cart.timeEdit.cartChange.cancelButton"),
                    arrow: "",
                    reverse: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("close")
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.$t("cart.timeEdit.cartChange.acceptButton")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onTimeChange(true)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }